<template>
  <div class="widget">
    <slot />

    <WidgetFavourites
      v-if="favouriteWidget"
      v-bind="favouriteWidget"
    />

    <WidgetLastGames
      v-else-if="lastGamesWidget"
      v-bind="lastGamesWidget"
    />

    <SliderWidget v-else-if="sliderWidget" v-bind="sliderWidget" />
    <ExpandList
      v-else-if="expandList"
      :key="expandList.paramPage"
      :query-key="expandList.paramPage"
      :fetch-method="expandList.fetchMethod"
      :param-page="expandList.paramPage"
      :list-type="expandList.listType"
      :parent-term="expandList.parentTerm"
      :prop-data="expandList.data"
      is-auto-pagination
    >
      <template #default>
        <HeadlineAction
          :title="expandList.title"
          :img="expandList.img"
          class="expand-list-header"
        />
      </template>
    </ExpandList>

    <WidgetComprehensive
      v-else-if="widgetComprehensiveAttrs"
      class="promotion-previews"
      v-bind="widgetComprehensiveAttrs"
      @resize="widgetComprehensiveUpdate"
    />

    <WidgetCollapces
      v-else-if="widgetCollapces"
      :widgets="widgetCollapces"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import WidgetComprehensive from '@/components/shared/Widgets/WidgetComprehensive'
import WidgetCollapces from '@/components/shared/Widgets/WidgetCollapces'
import WidgetFavourites from '@/components/Lobby/UserGames/WidgetFavourites'
import WidgetLastGames from '@/components/Lobby/UserGames/WidgetLastGames'
import SliderWidget from '@/components/shared/Widgets/SliderWidget'
import { MODEL_TYPE, GAME_TYPE, LIST_TYPE, AUTO_CONDITION, VIEW_TYPE } from '@/components/Lobby/enum.js'
import { getLangText } from '@/components/Lobby/helpers.js'
import ExpandList from '~/components/Lobby/ExpandList'
import HeadlineAction from '@/components/shared/HeadlineAction'
import PromotionsMapper from '@/components/shared/Cards/CardPromotionPreview/mapper'

export default {
  name: 'TypeWidgets',
  components: {
    WidgetComprehensive,
    WidgetCollapces,
    WidgetFavourites,
    WidgetLastGames,
    SliderWidget,
    ExpandList,
    HeadlineAction,
  },
  props: {
    widget: { type: Object },
    currentSection: { type: Object },
    index: { type: Number },
    gameCard: { type: String, default: 'CardGame' },
  },
  data() {
    return {
      dinamicRow: 1,
      dinamicSkipIndexes: [],
    }
  },
  computed: {
    ...mapGetters('media', ['isMobile', 'width']),
    sliderWidget() {
      if (this.widget.modelType !== MODEL_TYPE.SLIDE) return
      const slides = this.widget.slides
      return {
        slides,
        hasFeatureCard: this.index === 0,
      }

    },
    expandList() {
      if (this.widget.viewType !== VIEW_TYPE.GRID) return
      const widgetContent = this.widget.subsection
      if (!widgetContent) return null
      const title = this.defaultInto.title || getLangText(widgetContent.nameUa, widgetContent.nameRu, this.$i18n)
      const img = this.defaultInto.icon || `${this.$config.cloudUrl}${widgetContent.iconUrl}`

      return {
        fetchMethod: this.fetch_subsectionItem,
        paramPage: widgetContent.term,
        listType: widgetContent.type,
        parentTerm: widgetContent.gameSectionTerm,
        title,
        img,
        data: widgetContent,
      }
    },
    favouriteWidget() {
      const widgetContent = this.widget.subsection
      if (!widgetContent) return null
      if (widgetContent.autoCondition !== AUTO_CONDITION.FAVOURITE) return
      return {
        term: widgetContent.term,
        data: widgetContent,
      }
    },
    lastGamesWidget() {
      const widgetContent = this.widget.subsection
      if (!widgetContent) return null
      if (widgetContent.autoCondition !== AUTO_CONDITION.LAST_GAMES) return
      return {
        term: widgetContent.term,
        data: widgetContent,
      }
    },
    defaultInto() {
      const widget = this.widget
      if (!widget) return {}
      return {
        icon: widget.customIconUrl && `${this.$config.cloudUrl}${widget.customIconUrl}`,
        title: getLangText(widget.customNameUa, widget.customNameRu, this.$i18n),
      }
    },
    widgetCollapces() {
      const modelType = this.widget.modelType
      if (modelType !== MODEL_TYPE.SUBSECTIONS) return null

      if (!this.widget.subsections[0]) return

      return this.widget.subsections?.map((el) => {
        if (!el) return null

        const to = this.localePath(`/${el.term}`)
        const gamesLength = el.games?.total

        return {
          games: el.games?.result.slice(0, 4) || [],
          remainder: gamesLength > 4 ? gamesLength - 4 : null,
          title: getLangText(el.nameUa, el.nameRu, this.$i18n),
          desc: getLangText(el.descriptionUa, el.descriptionRu, this.$i18n),
          to,
          src: `${this.$config.cloudUrl}${el.iconUrl}`,
        }
      })
    },
    widgetComprehensiveAttrs() {
      const modelType = this.widget.modelType

      if (modelType === MODEL_TYPE.TOURNAMENTS) return this.widgetTournaments
      if (modelType === MODEL_TYPE.SUBSECTION) return this.widgetSubsection
      if (modelType === MODEL_TYPE.SECTION) return this.widgetSection
      if (modelType === MODEL_TYPE.PROMOTIONS) return this.widgetPromotions

      return null
    },
    widgetPromotions() {
      const widgetContent = this.widget.promotionBanners
      if (!widgetContent) return
      const title = this.defaultInto.title
      const img = this.defaultInto.icon
      const list = widgetContent
      const row = this.widget.linesCount
      const usesCard = { name: 'CardPromotionPreview' }
      const linkBtn = this.$paths.bonusList
      const mappedList = list.map(PromotionsMapper.fromWidgetToCard)

      return {
        list: mappedList,
        title,
        img,
        row,
        usesCard,
        linkBtn,
      }
    },
    widgetTournaments() {
      const widgetContent = this.widget.tournaments
      if (!widgetContent) return

      const list = widgetContent.result
      if (!list) return
      const title = this.defaultInto.title
      const img = this.defaultInto.icon
      const row = 1
      const linkBtn = this.$paths.tournaments
      const usesCard = { name: 'CardTournament' }

      return {
        list,
        title,
        img,
        row,
        linkBtn,
        usesCard,
      }
    },
    widgetSubsection() {
      const widgetContent = this.widget.subsection
      if (!widgetContent) return null

      const title = this.defaultInto.title || getLangText(widgetContent.nameUa, widgetContent.nameRu, this.$i18n)
      const headerText = widgetContent.descriptionUa ? getLangText(widgetContent.descriptionUa, widgetContent.descriptionRu, this.$i18n) : null
      const img = this.defaultInto.icon || `${this.$config.cloudUrl}${widgetContent.iconUrl}`
      const parentTerm = widgetContent.gameSectionTerm
      const linkBtn = this.localePath(`/${parentTerm}/${widgetContent.term}`)
      const banner = widgetContent.banner
      const row = this.widget.linesCount

      const options = {
        title,
        headerText,
        img,
        linkBtn,
        parentTerm, // TODO: test w3c errors
        row,
      }

      const games = widgetContent?.games?.result
      const providers = widgetContent?.providers?.result
      const collections = widgetContent?.collections?.result

      if (games?.length) return this.buildSubsectionGames({ items: games, options, banner })
      if (providers?.length) return this.buildSubsectionProviders({ items: providers, options })
      if (collections?.length) return this.buildSubsectionCollections({ items: collections, options })

      return null
    },
    widgetSection() {
      const widgetContent = this.widget.section
      if (!widgetContent) return null
      const linkBtn = `/${widgetContent.term}`
      const list = widgetContent?.subsections?.result?.map((el) => {
        return {
          ...el,
          name: getLangText(el.nameUa, el.nameRu, this.$i18n),
          iconUrl: `${this.$config.cloudUrl}${el.iconUrl}`,
          term: this.localePath(`${linkBtn}/${el.term}`),
        }
      })
      if (!list?.length) return null
      const title = this.defaultInto.title || getLangText(widgetContent.nameUa, widgetContent.nameRu, this.$i18n)
      const img = this.defaultInto.icon || `${this.$config.cloudUrl}${widgetContent.iconUrl}`
      const row = 1
      const usesCard = { name: 'CardCategory' }

      return {
        list,
        title,
        img,
        row,
        linkBtn,
        usesCard,
      }
    },
  },
  mounted() {
    if (this.widgetSubsection) {
      this.widgetComprehensiveUpdate()
    }
  },
  methods: {
    ...mapActions('lobby', [
      'fetch_subsectionItem',
    ]),
    buildSubsectionGames({ items, options, banner }) {
      const list = [...items]
      const usesCard = { name: this.gameCard }

      if (list[0].type === GAME_TYPE.LIVE) {
        usesCard.attrs = {
          isLarge: true,
        }
      }

      return {
        ...options,
        list,
        usesCard,
      }
    },
    buildSubsectionProviders({ items, options }) {
      const isTypesPage = this.currentSection?.listType === LIST_TYPE.PROVIDER.NAME
      const list = [...items]

      const PROVIDERS_LAYOUT_BREAKPOINT = 1024

      const rowHasBanner = this.width <= PROVIDERS_LAYOUT_BREAKPOINT ? 1 : 2

      const usesCard = {
        name: 'CardProvider',
      }
      let firstSlideCard = null

      const hasStaticSlide = !Object.keys(this.$route.params).length

      if (hasStaticSlide) {
        firstSlideCard = {
          name: 'CardProviderFirst',
        }
      }

      return {
        ...options,
        linkBtn: isTypesPage ? null : this.localePath(`/${options.parentTerm}`),
        firstSlideCard,
        list,
        row: hasStaticSlide ? rowHasBanner : 1,
        usesCard,
      }
    },
    buildSubsectionCollections({ items, options }) {
      const isTypesPage = this.currentSection?.listType === LIST_TYPE.COLLECTION.NAME
      const list = [...items]

      const usesCard = {
        name: 'CardCollection',
        attrs: {
          parentTerm: options.parentTerm,
        },
      }
      const row = 1

      return {
        ...options,
        linkBtn: isTypesPage ? null : this.localePath(`/${options.parentTerm}`),
        list,
        row,
        usesCard,
      }
    },
    changeProviderTable() {
      if (this.isMobile) {
        this.dinamicSkipIndexes = [ 1 ]
        this.dinamicRow = 1
      }
      else {
        this.dinamicSkipIndexes = null
        this.dinamicRow = 2
      }
    },
    widgetComprehensiveUpdate() {
      setTimeout(() => {
        this.changeProviderTable()
      }, 1000)
    },
  },
}
</script>

<style lang="scss" scoped>
.expand-list-header {
  margin-bottom: 16px;

  @include media(tablet) {
    margin-bottom: 24px;
  }
}
</style>
